import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import propTypes from 'prop-types';
import { MachineTranslationButton } from '@fiverr-private/machine_translation';
import tracker from '../../../utils/reports/TrackingService';

import './styles.scss';

const getSourceInfo = (componentName) => {
    const trackerData = tracker.getReportingData();
    const summarizeData = { component: { name: componentName } };

    return _.merge({}, trackerData, summarizeData);
};

const TranslationButton = ({ translationConfig, componentName }) => {
    const sourceInfo = getSourceInfo(componentName);
    const buttonWrapperClassNames = classnames('translate-btn-wrapper', {
        toggled: translationConfig.isTranslatedText,
        'is-loading': translationConfig.isLoading,
    });

    return (
        <div className={buttonWrapperClassNames}>
            <MachineTranslationButton
                style={MachineTranslationButton.STYLES.LEAN_WITH_DISCLAIMER}
                onClick={() => translationConfig.toggleTranslation(sourceInfo)}
                toggled={translationConfig.isTranslatedText}
                loading={translationConfig.isLoading}
                sourceInfo={sourceInfo}
                showDisclaimerText={false}
            />
        </div>
    );
};

TranslationButton.propTypes = {
    translationConfig: propTypes.object.isRequired,
    componentName: propTypes.string.isRequired,
};

export default TranslationButton;
